/**
 * **Tablets work** (OQ-D32, STORY-219): on a touch screen the page carries
 * `data-touch="true"`, and `index.css` gives every control a finger-sized
 * target and shows what a mouse would have found by hovering. A desktop keeps
 * its density untouched.
 *
 * `(pointer: coarse)` is the primary signal; touch points cover a tablet with a
 * keyboard attached, whose pointer reports as fine while a finger is still what
 * reaches the screen. Re-checked when the pointer changes (a detachable tablet).
 */
export function watchTouch(): void {
  const coarse = window.matchMedia("(pointer: coarse)");
  // `dentacore.forceTouch` = "1" in localStorage tries the touch layout on a
  // desktop, which is how it is measured: browsers emulating a tablet's size
  // still report a fine pointer.
  let forced = false;
  try {
    forced = localStorage.getItem("dentacore.forceTouch") === "1";
  } catch {
    // Storage blocked: the device decides.
  }
  const apply = (): void => {
    const touch = forced || coarse.matches || navigator.maxTouchPoints > 0;
    if (touch) document.documentElement.dataset.touch = "true";
    else delete document.documentElement.dataset.touch;
  };
  apply();
  coarse.addEventListener("change", apply);
}
